
import "C:/github-runners/esig-portal/_work/esig-client/esig-client/src/components/Trend/styles.less?modules";
export default {"reverseColor": `reverseColor-mftJyfvM`,"trendItemGrey": `trendItemGrey-Qub7LkX8`,"up": `up-4o_lkYW6`,"down": `down-NJpyfgIN`,"trendItem": `trendItem-zU4DGNO5`}
